import type { TerraUIMessagePart } from '@terra/shared-dto-chat-types';

export function getMessageContentPart(
  message: TerraUIMessagePart,
  type: TerraUIMessagePart['type'],
) {
  switch (type) {
    case 'text': {
      if (message.type !== 'text') {
        console.warn(
          `getMessageContentPart: Expected message part of type 'text', but got '${message.type}'.`,
          message,
        );
        return undefined;
      }
      return message.text;
    }
    case 'reasoning': {
      if (message.type !== 'reasoning') {
        console.warn(
          `getMessageContentPart: Expected message part of type 'reasoning', but got '${message.type}'.`,
          message,
        );
        return undefined;
      }
      return message.text;
    }
    case 'file': {
      if (message.type !== 'file') {
        console.warn(
          `getMessageContentPart: Expected message part of type 'file', but got '${message.type}'.`,
          message,
        );
        return undefined;
      }
      // Some file parts may have a filename or text, adjust as needed
      return message.filename;
    }
    default: {
      console.warn(
        `getMessageContentPart: Unsupported message part type: ${type}`,
        message,
      );
      return undefined;
    }
  }
}
